import React, { useEffect, useState } from "react";
import CssTransition from "../../../../component/layout/css-transition";
import UserInfoTile from "./UserInfoTile";
import TeamUsers from "./TeamUsers";
import { createBookingGroup, getBookingGroups, getUserListForBooking } from "../../../../redux/actions/todoPerformance";
import { useDispatch, useSelector } from "react-redux";
import SimpleBarReact from "simplebar-react";
import "simplebar-react/dist/simplebar.min.css";
import CustomeModal from "../../../../component/modal-popup/customeModal";
import swal from "@sweetalert/with-react";

const CreateGroupModel = ({
  modalOpen,
  setModelOpen,
  activity_assignment_id,
}) => {
  const dispatch = useDispatch();
  const { userList } = useSelector((state) => state.todoPerformance);
  const { id, email, type } = useSelector(state => state.auth);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [memberList, setMemberList] = useState({});
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (modalOpen) {
      dispatch(getUserListForBooking(activity_assignment_id));
    }
    return () => {
      setSelectedUsers([]);
      setMemberList([]);
      setLoading(false);
    };
  }, [modalOpen]);

  useEffect(() => {
    setMemberList(userList);
  }, [userList]);

  const handleCancel = (e) => {
    e.preventDefault();
    setModelOpen(false);
  };

  const handleSelectAll = (e) => {
    e.preventDefault();

    setSelectedUsers((prev) => {
      let list = [...prev]
      for (const item of userList.departments) {
        for (const ele of item.users) {
          const check = list.find((e) => e.id === ele.id);
          if (check) {
            continue;
          }
          list.push(ele);
        }
      }
      for (const item of userList.collaborators) {
        const check = list.find((e) => e.id === item.id);
        if (check) {
          continue;
        }
        list.push(item);
      }
      return list;
    });

    setMemberList((prev) => {
      prev.departments = prev.departments.map((item) => {
        return {
          ...item,
          users: [],
        };
      });
      prev.collaborators = [];
      return prev;
    });
  };

  const handleSelectTeam = (users) => {
    setSelectedUsers((prev) => {
      const list = [...prev];
      for (const ele of users) {
        const check = list.find((e) => e.id === ele.id);
        if (check) {
          continue;
        }
        list.push(ele);
      }
      return list;
    });
    setMemberList((prev) => {
      prev.departments = prev.departments.map((item) => {
        let user = item.users;
        for (const ele of users) {
          user = user.filter((e) => e.id !== ele.id);
        }
        return {
          ...item,
          users: user,
        };
      });
      return prev;
    });
  };

  const handleRemoveUser = (user) => {
    setSelectedUsers((prev) => {
      return prev.filter((item) => item.id !== user.id);
    });
    setMemberList((prev) => {
      if (user.dept_id) {
        prev.departments = prev.departments.map((item) => {
          let users = item.users;          
          if (user.dept_id?.includes(item.dept_id)) {
            users = [...item.users, user];
          }
          return {
            ...item,
            users: users,
          };
        });
      } else {
        prev.collaborators = [...prev.collaborators, user];
      }

      return prev;
    });
  };

  const handleSelectUser = (user) => {
    setSelectedUsers((prev) => {
      const list = [...prev];
      const check = list.find((e) => e.id === user.id);
      if (!check) {
        list.push(user);
      }
      return list;
    });
    setMemberList((prev) => {
      prev.departments = prev.departments.map((item) => {
        let users = item.users.filter((e) => e.id !== user.id);
        return {
          ...item,
          users: users,
        };
      });
      prev.collaborators = prev.collaborators.filter((item) => item.id !== user.id);
      return prev;
    });
  };

  const handleCreate = (e) => {
    e.preventDefault();
    setLoading(true)
    let user_emails = new Set();
    let user_ids = new Set();
    let group_name = "Internal Chat";
    selectedUsers.forEach((item) => {
      user_emails.add(item.email);
      user_ids.add(item.id);
    });

    const check_collaborator = selectedUsers.find((item) =>
      ["collaborator", "customer"].includes(item?.type)
    );
    if (check_collaborator) {
      group_name =
        check_collaborator.type === "customer"
          ? "Customer Included"
          : "Collaborator Included";
    }

    if (selectedUsers.length === 1) {
      group_name = selectedUsers[0].name;
      user_emails.add(email);
      user_ids.add(id);
    }

    if([...user_emails].length === 0){
      return;
    }

    const check = [...user_emails].find(item => item === email);

    if(!check && [...user_emails].length > 1 && !["super-admin"].includes(type)){
      swal({
        content: (
          <CustomeModal
            type="warning"
            title="Warning!"
            content={"You are not included in user list of group. Please add your self in group user list to create."}
          />
        ),
        buttons: false,
        closeOnClickOutside: false,
        closeOnEsc: false,
      });
      return;
    }

    const payload = {
      user_emails: [...user_emails],
      user_ids: [...user_ids],
      group_name: group_name,
      activity_assignment_id: activity_assignment_id
    }

    dispatch(createBookingGroup(payload, (res) => {
      setLoading(false);
      setModelOpen(false);
      if (res.status === 1) {
        swal({
          content: (
            <CustomeModal
              type="success"
              title="Success!"
              content="Group is added successfully."
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
        dispatch(getBookingGroups(activity_assignment_id, () => {}))
      } else if (res.status === 0) {
        const message = res.message === "Duplicate entry" ? "Group name is already exists with selected users." : "Unable to create group, please try again."
        swal({
          content: (
            <CustomeModal
              type="error"
              title="Error!"
              content={message}
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      }
    }));

  };

  return (
    <div>
      <CssTransition
        className="fixed inset-0 bg-slate-900 bg-opacity-30 z-50 transition-opacity"
        show={modalOpen}
        enter="transition ease-out duration-200"
        enterStart="opacity-0"
        enterEnd="opacity-100"
        leave="transition ease-out duration-100"
        leaveStart="opacity-100"
        leaveEnd="opacity-0"
        aria-hidden="true"
        id="modal3"
      />
      <CssTransition
        className="fixed inset-0 z-50 flex items-center my-4 justify-center px-4 sm:px-6 overflow-y-auto"
        role="dialog"
        aria-modal="true"
        show={modalOpen}
        enter="transition ease-in-out duration-200"
        enterStart="opacity-0 translate-y-4"
        enterEnd="opacity-100 translate-y-0"
        leave="transition ease-in-out duration-200"
        leaveStart="opacity-100 translate-y-0"
        leaveEnd="opacity-0 translate-y-4"
        id="modal4"
      >
        <div className="bg-white overflow-auto max-w-3xl w-full rounded-3xl shadow-lg flex flex-col p-5">
          <p className="text-[18px] font-semibold font-inter text-center pt-6">
            New Chat
          </p>
          <div className="pt-3">
            <p className="text-[16px] font-inter text-center ">
              Please select the participants
            </p>
            <p className="text-[16px] font-inter text-center">
              you want to add to this new chat.
            </p>
          </div>
          <div className="mt-6 p-5">
            <div className="w-full grid grid-cols-2 gap-x-10">
              {/* max-h-[100px] overflow-y-scroll */}
              <SimpleBarReact forceVisible="y" style={{ maxHeight: "350px" }}>
                <div className="min-h-[350px]">
                  <div>
                    <div className="flex items-center justify-between">
                      <div className="text-[14px] font-semibold font-inter text-[#1E293B]">
                        Available Users
                      </div>
                      <div
                        onClick={handleSelectAll}
                        className="text-[10px] font-semibold font-inter text-[#2F80ED] cursor-pointer"
                      >
                        Select All
                      </div>
                    </div>

                    {Object.keys(memberList).length > 0 &&
                      memberList.collaborators?.map((item) => (
                        <UserInfoTile
                          key={item.id}
                          user={item}
                          selectedUsers={selectedUsers}
                          handleSelectUser={handleSelectUser}
                          is_selected={true}
                        />
                      ))}
                  </div>
                  {Object.keys(memberList).length > 0 &&
                    memberList.departments?.map(
                      (item) =>
                        item.users?.length > 0 && (
                          <TeamUsers
                            key={item.dept_id}
                            team_name={item.dept_name}
                            users={item.users}
                            selectedUsers={selectedUsers}
                            handleSelectTeam={handleSelectTeam}
                            handleSelectUser={handleSelectUser}
                          />
                        )
                    )}
                </div>
              </SimpleBarReact>
              <SimpleBarReact forceVisible="y" style={{ maxHeight: "350px" }}>
                <div className="min-h-[350px]">
                  <div className="flex items-center justify-between">
                    <div className="text-[14px] font-semibold font-inter text-[#1E293B]">
                      Users Added To Chat
                    </div>
                  </div>
                  {selectedUsers.map((item) => (
                    <UserInfoTile
                      key={item.id}
                      user={item}
                      is_add={true}
                      handleRemoveUser={handleRemoveUser}
                    />
                  ))}
                </div>
              </SimpleBarReact>
            </div>
          </div>
          <div className="my-3 grid grid-cols-2 gap-x-3 px-5">
            <button
              className="btn !bg-white border !border-slate-200 hover:!border-slate-300"
              onClick={handleCancel}
            >
              Cancel
            </button>
            <button
              onClick={handleCreate}
              className={`btn text-white text-sm font-medium leading-5 ${
                loading
                  ? "!bg-[--bg-color-300] pointer-events-none"
                  : "!bg-[--bg-color-500] hover:!bg-[--bg-color-600]"
              }`}
            >
              Create
              {loading && (
                <span className="ml-2">
                  <svg
                    className="animate-spin w-4 h-4 fill-current shrink-0"
                    viewBox="0 0 16 16"
                  >
                    <path d="M8 16a7.928 7.928 0 01-3.428-.77l.857-1.807A6.006 6.006 0 0014 8c0-3.309-2.691-6-6-6a6.006 6.006 0 00-5.422 8.572l-1.806.859A7.929 7.929 0 010 8c0-4.411 3.589-8 8-8s8 3.589 8 8-3.589 8-8 8z" />
                  </svg>
                </span>
              )}
            </button>
          </div>
        </div>
      </CssTransition>
    </div>
  );
};

export default CreateGroupModel;
